// extracted by mini-css-extract-plugin
export default {"base":"vp_nFKRp","selected":"vp_i6p03"};